export const DEFAULT_PAGINATION_PAGE_SIZE = 100 as const;
export const DEFAULT_PAGINATION_PAGE_SIZE_COMPONENTS = 500 as const;

export const recordCountOptions = [
  { value: '50', label: '50' },
  { value: '100', label: '100' },
  { value: '500', label: '500' },
  { value: '1000', label: '1000' },
  { value: 'all', label: 'All' }
];
